import { combineReducers } from 'redux';
import { authTokenReducer, twoFactorRequiredReducer } from './auth/reducer.js';
import * as singleCase from './case/reducer.js';
import * as caseVouchersReducers from './case-vouchers/reducer.js';
import * as cases from './cases/reducer.js';
import { SITE } from './config.js';
import * as creditors from './creditors/reducer.js';
import * as customers from './customers/reducer.js';
import * as economy from './economy/reducer.js';
import selectedExclusiveContentReducer from './exclusiveContent/reducer.js';
import { homeReducer, pausedCasesReducer, pendingCasesReducer, } from './home/reducer.js';
import * as hooks from './hooks/reducer.js';
import { importsReducer, importReducer, appendicesReducer, } from './imports/reducer.js';
import * as insights from './insights/reducer.js';
import * as integrations from './integrations/reducer.js';
import { interactionsReducer } from './interactions/reducer.js';
import * as keys from './keys/reducer.js';
import { langReducer, currentLangReducer } from './lang/reducer.js';
import { leftNavOpenReducer, rightNavOpenReducer } from './local/reducer.js';
import meReducer from './me/reducer.js';
import newInteractionsReducer from './newInteractions/reducer.js';
import proceduresReducer from './procedures/reducer.js';
import redirectReducer from './redirect/reducer.js';
import selectedOwnersReducer from './selectedOwners/reducer.js';
import { templateReducer, templateMapReducer } from './templates/reducer.js';
import tenantReducer from './tenant/reducer.js';
import * as transactionAccountsReducer from './transaction-accounts/reducer.js';
import updateTypeGroupsReducer from './update-type-groups/reducer.js';
import { updateTypesReducer, updateTypesMapReducer, } from './update-types/reducer.js';
import * as users from './users/reducer.js';
import * as voucherApplications from './voucher-applications/reducer.js';
import * as workflows from './workflows/reducer.js';
console.log(SITE);
const appReducer = combineReducers({
    activeUsers: users.activeUsersReducer,
    allUsers: users.allUsersReducer,
    authToken: authTokenReducer,
    caseFilter: insights.caseFilterReducer,
    caseFilterCount: insights.caseFilterCountReducer,
    caseFilterQueue: insights.caseFilterQueueReducer,
    hooks: hooks.getHooksReducer,
    keys: keys.getKeysReducer,
    caseSatisfactions: singleCase.caseSatisfactionsReducer,
    caseUpdates: singleCase.caseUpdatesReducer,
    cases: cases.casesReducer,
    transactionAccounts: transactionAccountsReducer.transactionAccountsReducer,
    transactionImports: transactionAccountsReducer.transactionImportReducer,
    caseVouchersList: caseVouchersReducers.caseVouchersListReducer,
    caseVouchers: caseVouchersReducers.caseVouchersReducer,
    workflows: workflows.workflowsReducer,
    currentLang: currentLangReducer,
    customers: customers.customersReducer,
    economyVoucherTypes: economy.VoucherTypesReducer,
    economyVoucherTypesMap: economy.VoucherTypesMapReducer,
    economyDepositsInsights: economy.DepositsInsightsReducer,
    home: homeReducer,
    interactions: interactionsReducer,
    allImports: importsReducer,
    imports: importReducer,
    amountAppendices: appendicesReducer,
    lang: langReducer,
    leftNavOpen: leftNavOpenReducer,
    me: meReducer,
    newInteractions: newInteractionsReducer,
    pausedCases: pausedCasesReducer,
    pendingCases: pendingCasesReducer,
    procedures: proceduresReducer,
    redirectTo: redirectReducer,
    rightNavOpen: rightNavOpenReducer,
    selectedCreditor: creditors.selectedCreditorReducer,
    selectedOwners: selectedOwnersReducer,
    selectedExclusiveContent: selectedExclusiveContentReducer,
    site: () => SITE,
    templates: templateReducer,
    templatesMap: templateMapReducer,
    tenant: tenantReducer,
    twoFactorRequired: twoFactorRequiredReducer,
    updateTypes: updateTypesReducer,
    updateTypesMap: updateTypesMapReducer,
    updateTypeGroups: updateTypeGroupsReducer,
    users: users.usersReducer,
    integrations: integrations.integrationsReducer,
    integrationList: integrations.integrationListReducer,
    integrationActivations: integrations.integrationActivationReducer,
    creditorIntegrationActivations: integrations.creditorIntegrationActivationsReducer,
    missingApplications: integrations.missingApplicationsReducer,
    voucherApplications: voucherApplications.VoucherApplicationsReducer,
});
const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
export default rootReducer;
//# sourceMappingURL=reducer.js.map